import React, { useState, useEffect } from 'react';
import { resetPassword } from 'aws-amplify/auth';
import { Form, Button, Spinner } from 'react-bootstrap';
import { useNavigate } from "react-router-dom";

import toastr from "toastr";

function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    document.body.className = 'login';
  }, []);

  const gotoSuccess = (e) => {
    navigate('/changepassword', { state: { email: email } });
  }

  async function handleResetPassword(e) {
    e.preventDefault();
    setLoading(true);
    try {
      if (email === '') {
        setLoading(false);
        toastr.warning('Preencha todos os campos obrigatórios');
        return;
      }
      const output = await resetPassword({ username: email });
      handleResetPasswordNextSteps(output);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
      if (error.name === 'CodeDeliveryFailureException') {
        toastr.error('Ocorreu um erro ao enviar o código de validação, confira se o email informado é válido');
      } else if (error.name === 'UserNotFoundException') {
        toastr.error('O usuário não existe');
      } else {
        toastr.error('Ocorreu um erro ao solicitar alteração de senha');
      }
    }
  }

  function handleResetPasswordNextSteps(output) {
    const { nextStep } = output;
    switch (nextStep.resetPasswordStep) {
      case 'CONFIRM_RESET_PASSWORD_WITH_CODE':
        const codeDeliveryDetails = nextStep.codeDeliveryDetails;
        toastr.success(`Um código de confirmação foi enviado para ${email}`);
        gotoSuccess();
        break;
    }
  }

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };


  return (
    <div className='panel-login'>
      <img src={process.env.PUBLIC_URL + '/static/imagens/logo.svg'} className='display--block margin--auto' alt='Logomarca' />
      <h1 className='title-login text-center'>Um link com um código de validação <br />será enviado para seu e-mail</h1>
      <Form onSubmit={handleResetPassword}>
        <Form.Group controlId="formBasicEmail" className='group-input--big' style={{ marginTop: "70px", marginBottom: "160px" }}>
          <Form.Label>Email*:</Form.Label>
          <Form.Control type="text" value={email} onChange={handleEmailChange} className='input--big' />
        </Form.Group>

        {loading ?
          <div className="text-center">
            <Spinner animation="border" variant="success" />
          </div>
          :
          <Button variant="primary" type="submit" className='margin--auto display--block'>
            Enviar
          </Button>
        }
      </Form>
    </div>
  );
};

export default ForgotPassword;


